import { TFunction } from 'i18next';

import { ADDON_KIND, VOICE_ADDONS_KINDS } from '@app/constants';

export const getActionLabelByKind = (kind: string, t: TFunction): string => {
  if (VOICE_ADDONS_KINDS.includes(kind)) {
    return t('addOns.manageVoice');
  }

  if (kind === ADDON_KIND.CYBER_PROTECT) {
    return t('addOns.manageCyberProtect');
  }

  return '';
};
